// src/screens/BillCountScreen.js
import React, { useContext } from 'react';
import CountContext from '../context/CountContext.js';

export default function BillCountScreen({ onNext, onBack }) {
  const { state, dispatch } = useContext(CountContext);
  const bills = state.bills;

  // Called on every keystroke; writes straight into context
  const handleChange = (billType) => (e) => {
    let raw = e.target.value.replace(/^0+(?=\d)/, '');
    if (raw === '') raw = '0';
    const count = parseInt(raw, 10);
    dispatch({ type: 'UPDATE_BILL', payload: { billType, count } });
  };

  // Optional: show total of bills
  const billsValue = Object.entries(bills)
    .reduce((sum, [key, count]) => {
      const denom = { ones: 1, fives: 5, tens: 10, twenties: 20, fifties: 50, hundreds: 100 }[key];
      return sum + count * denom;
    }, 0)
    .toFixed(2);

  return (
    <div className="p-4 max-w-md mx-auto bg-white rounded-2xl shadow-lg">
      <h2 className="text-2xl font-bold mb-4">Bill Count</h2>
      <p className="mb-4 italic text-sm text-gray-600">
        Don’t forget to check the green box for stacks of one-dollar bills.
      </p>

      <div className="space-y-3">
        {[
          { key: 'ones', label: 'Ones', denom: 1 },
          { key: 'fives', label: 'Fives', denom: 5 },
          { key: 'tens', label: 'Tens', denom: 10 },
          { key: 'twenties', label: 'Twenties', denom: 20 },
          { key: 'fifties', label: 'Fifties', denom: 50 },
          { key: 'hundreds', label: 'Hundreds', denom: 100 },
        ].map(({ key, label, denom }) => (
          <div key={key} className="flex items-center space-x-4">
            <label className="w-32">{label} (${denom})</label>
            <input
              type="number"
              min="0"
              value={bills[key]}
              onChange={handleChange(key)}
              onFocus={(e) => e.target.select()}
              className="border rounded p-1 w-20"
            />
            <span>= ${(bills[key] * denom).toFixed(2)}</span>
          </div>
        ))}
      </div>

      <div className="mt-4 font-bold">Total Bills: ${billsValue}</div>

      <div className="mt-6 flex space-x-4">
        <button
          onClick={onBack}
          className="px-4 py-2 bg-gray-300 rounded"
        >
          Back
        </button>
        <button
          onClick={() => {
            
            onNext();
          }}
          className="px-4 py-2 bg-blue-500 text-white rounded"
        >
          Confirm Bills
        </button>

      </div>
    </div>
  );
}


